import { Injectable } from '@angular/core';
import {MatSnackBar} from "@angular/material/snack-bar";
import {MsgSnackbarComponent, SnackbarMsg} from "../msg-snackbar/msg-snackbar.component";

@Injectable({ providedIn: 'root' })
export class CustomSnackbarService {

    constructor(
      public snackBar: MatSnackBar
    ) {}

    public open(message, SnackbarTypeError,duration = 1600) {
      let msgData = new SnackbarMsg(SnackbarTypeError, message);
      this.snackBar.openFromComponent(MsgSnackbarComponent, {data: msgData, duration});
    }
}
